export default __webpack_public_path__ + "static/media/981.f650782c.gif";